var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ticket-content"},[_c('h3',[_vm._v(_vm._s("پیام"))]),_c('vs-row',[(_vm.titleVisible)?_c('vs-col',[_c('p',{staticClass:"mb-1"},[_vm._v(_vm._s("موضوع"))]),_c('vs-input',{staticClass:"w-100 mt-1",model:{value:(_vm.title),callback:function ($$v) {_vm.title=$$v},expression:"title"}})],1):_vm._e(),_c('vs-col',[_c('editor',{ref:"editorRef",attrs:{"api-key":_vm.editorApiKey,"init":{
          height: 350,
          width: '100%',
          menubar: false,
          branding: false,
          color_default_foreground: '#fff',
          statusbar: false,
          plugins: [
            'advlist',
            'autolink',
            'lists',
            'link',
            'image',
            'charmap',
            'preview',
            'anchor',
            'searchreplace',
            'visualblocks',
            'code',
            'fullscreen',
            'insertdatetime',
            'media',
            'table',
            'code',
            'help',
            'wordcount' ],
          toolbar: 'bold italic ' + '| bullist numlist outdent indent',
          // toolbar:
          //   'bold italic | alignleft aligncenter ' +
          //   'alignright alignjustify | bullist numlist outdent indent',
          content_style: "body { direction: rtl; }",
        }},model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }